/**
 * ユーザー登録 バリデーションルール
 */
export default {
  shopId: 'required|numeric|min_value:1',
  name: 'required|max:255',
  priceRangeId: 'required',
  seatCount: 'required|numeric|min_value:1',
  faspaShopId: 'numeric|min_value:1',
  takeoutShopId: 'numeric|min_value:1',
  soShopLimit: 'required|numeric|between:0,99',
  soTableLimit: 'required|numeric|between:0,99',
  soPreLimit: 'required|numeric|between:0,99',
  soStatus: 'required|numeric|between:0,1',
  selfcheckEnabled: 'required|numeric|between:0,1',
  bikkuraponRateChangeEnabled: 'required|numeric|between:0,1',
  priceDisplayEnabled: 'required|numeric|between:0,1',
  bikkuraponIconDisplayEnabled: 'required|numeric|between:0,1',
}
